export default {
  getModelActivities(state){
    return state.modelActivities
  },
}
